<template>
  <master-main
    :exportProperties="{
      pdf: {
        filename: `${$t('labor.activities_rate')}.pdf`,
        route: `${getModuleRoute}/pdf`,
      },
      xls: {
        filename: `${$t('labor.activities_rate')}.xlsx`,
        route: `${getModuleRoute}/excel`,
      },
    }"
    :dataBadges="[
      {
        columnLabel: $t('common_words.companies2'),
        data: 'businesses',
        property: 'name',
        minWidth: 180,
      },
    ]"
    :route="getModuleRoute"
    :tableProperties="tableProperties"
    @closeModal="handleCloseModal"
    @openModal="handleOpenModal"
    @refresh="refresh"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    ref="masterMain"
  >
    <template slot="dialogForm">
      <edit-or-create-rate
        :syncDialog="modals"
        @addEdit="addEdit"
        @closeModal="handleCloseModal"
        @showHideLoading="showHideLoading"
        @showNotification="notifyVue"
        ref="editCreate"
      />
    </template>
  </master-main>
</template>
<script>
import EditCreate from './EditCreate.vue';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinWithDialog from 'src/mixins/master/mixin-with-dialog';
import RateTable from './activity-rates-table';

export default {
  components: { MasterMain, [EditCreate.name]: EditCreate },
  data() {
    return {
      tableProperties: {},
    };
  },
  mixins: [
    MixinAlert,
    MixinLoading,
    MixinMain,
    MixinPermissions,
    MixinWithDialog,
  ],
  computed: {
    getModuleRoute() {
      return 'works/activityrates';
    },
    buildTableProperties() {
      return {
        tableColumns: [...RateTable().tableColumns],
        model: 'activityrate',
        effectTags: 'dark',
        defaultSort: { prop: 'name', order: 'ascending' },
      };
    },
  },
};
</script>
